import React from 'react';

/* eslint-disable react/no-multi-comp */
export const __ = {
  reload: () => {
    /* istanbul ignore next */
    window.location.reload();
  },
  getUri: () => (
    /* istanbul ignore next */
    window.location.href
  ),
  openWindow: (url, options) => {
    /* istanbul ignore next */
    window.open(url, options);
  },
  assign: (uri) => {
    /* istanbul ignore next */
    window.location.assign(uri);
  },
};

export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];

    return reducer ?
      reducer(state, action.payload) :
      state;
  };
}

// allows to have reducers work on the same potion of a state object.
// usefull when splitting reducers under different components
export function reduceReducers(...reducers) {
  return (previous, current) =>
    reducers.reduce(
      (p, r) => r(p, current),
      previous,
    );
}

export function openWindow(url, options) {
  __.openWindow(url, options);
}

export function locationAssign(uri) {
  __.assign(uri);
}

export function reload() {
  __.reload();
}

export function postMessage(contentWindow, postText, targetOrigin) {
  /* istanbul ignore next */
  contentWindow.postMessage(postText, targetOrigin);
}

// convenience helper to encapsulate global.window.location.href attr
// useful for mocks/stubs while unit testing
export function getUri() {
  return __.getUri();
}

export function isLanguageSwitcher() {
  return process.env.LANGUAGE_SWITCHER;
}

export function wrapLink(content, url, className = {}) {
  return url ? (
    <a className={className.onTrue} href={url} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    <span className={className.onFalse}>{content}</span>
  );
}

export const escapeCsvCommands = (value) => {
  // The following must not be allowed as the first character of a field exported to CSV -> ["=", "+", "-", "@"].
  const startsWithCommandCharacters = /^(=|\+|-|@)/.test(value);
  if (startsWithCommandCharacters) return `'${value}`;
  return value;
};
